import { Component } from '@angular/core';

@Component({
  selector: 'uni-table-cell-content-header',
  templateUrl: './uni-table-cell-content-header.component.html',
  styleUrls: ['./uni-table-cell-content-header.component.scss']
})
export class UniTableCellContentHeaderComponent {}
